import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const RejectedButton = () => {
  return (
    <>
      <button
        className="btn btn-light ms-1"
        style={{
          fontSize: "12px",
          backgroundColor: " rgb(253, 226, 226)",
          color: " rgb(193,64,80)",
          paddingTop: "3px",
          paddingBottom: "2px",
          marginTop: "0px",
          marginBottom: "0px",
          paddingRight: "2px",
          paddingLeft: "1px",
          width: "76px",
          borderRadius: 0,
          fontFamily: "emoji",
          fontWeight: "700",
        }}
      >
        <FontAwesomeIcon
          icon={faXmark}
          style={{ marginRight: "3px", paddingTop: "2px" }}
        />
        <span className="">Rejected</span>
      </button>
    </>
  );
};

export default RejectedButton;
